<rpe-vista-mis-depositos-dependencias
  [vistaMisDepositosDependencias]="vistaMisDepositosDependencias"></rpe-vista-mis-depositos-dependencias>
